import React from "react"
import { alpha, Box, Grid, Typography, useTheme } from "@mui/material"
import { IconSeeker, TooltipSeeker } from "@ui-seeker/core"


export default function BITableCell(
	{
		price,
		evolutionChange,
		evolutionDiff,
		noResult,
		isCheapest,
		isMoreExpensive,
		prevPrice
	}) {
	const { palette } = useTheme()

	const evolutionIcons = {
		increase: { color: "success.dark", icon: "arrow-up" },
		decrease: { color: "error.main", icon: "arrow-down" },
		equal: { icon: "equals" },
	}

	let backgroundColor = ''
	if (isCheapest) backgroundColor = palette.success.main
	else if (isMoreExpensive) backgroundColor = palette.error.main
	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "space-around",
				flexDirection: "row",
				borderRadius: "5px",
				border: 2,
				width: 90,
				minHeight: 45,
				borderColor: !noResult ? backgroundColor || 'secondary.light' : 'transparent',
				backgroundColor: backgroundColor ? alpha(backgroundColor, 0.1) : 'transparent',
				userSelect: "none",
			}}
		>
			<Grid container>
				<Grid item xs={12} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
					<TooltipSeeker title="Current Price">
						<Typography variant="subtitle2" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
							{!!price ? `${price}` : 'N/A'}
						</Typography>
					</TooltipSeeker>
				</Grid>
				{(!!prevPrice && !noResult) && (
					<Grid item xs={5} sx={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "row" }}>
						<TooltipSeeker title="Previous Price">
							<Typography
								color="text.secondary"
								sx={{ display: 'flex', alignItems: 'center', gap: 0.5, fontWeight: "bold", fontSize: "0.7rem" }}>
								{!!prevPrice ? `${prevPrice}` : 'N/A'}
							</Typography>
						</TooltipSeeker>
					</Grid>
				)}
				{(!!evolutionChange && !noResult) && (
					<Grid item xs={7} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
						<TooltipSeeker title="Difference between current price and previous price" componentsProps={{ sx: { display: "flex" } }}>
							<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "row", gap: .25 }}>
								<IconSeeker {...evolutionIcons[evolutionChange]} sx={{ fontSize: "0.6rem" }}/>
								<Typography sx={{ fontSize: "0.7rem" }}>{evolutionDiff}%</Typography>
							</Box>
						</TooltipSeeker>
					</Grid>
				)}
			</Grid>
		</Box>
	</Box>
}